// extracted by mini-css-extract-plugin
export default {"root":"_3qBpu","label":"_2noOo","updated-ui":"_3iFg1","updatedUi":"_3iFg1"};